import React from 'react';
import Container from 'container';
import Headline from 'headline';
import Img from 'img';
import Icon from 'icon';
import Button from 'button';
import Counter from 'shared/counter';
import useCustomerAccessToken from 'hooks/useCustomerAccessToken';
import useGlobal from 'hooks/useGlobal';

import { Link } from 'gatsby';

import s from './cart.module.scss';

const headings = ['product', 'price', 'quantity', 'total'];

export default function Cart({ cart }) {
  const { customerAccessToken } = useCustomerAccessToken();
  const { state, emit } = useGlobal();

  if (!customerAccessToken) {
    return (
      <Container className={`${s.root} ${s.empty}`}>
        <div className={s.noItems}>
          <Headline h4>
           Limited Access
          </Headline>
          <p>
          It looks like you are not logged in yet, click
            {' '}
            <Link className={s.here} to="/login">here</Link>
            {' '}
          to get you on track
          </p>
        </div>
      </Container>
    );
  }
  return (
    <Container className={`${s.root} ${!cart.cartItems ? s.empty : ''}`}>
      {cart.cartItems ? (
        <ul className={s.wrapper}>
          <li className={s.headings}>
            <ul className={`${s.productsList} ${s.headingsList}`}>
              {headings.map(heading => {
                return (
                  <Headline
                    key={heading}
                    el="li"
                    className={`${s.cartItem} ${s.cartHeading} ${
                      s[heading || 'blank']
                    }`}
                    center
                    h6
                  >
                    {heading || ''}
                  </Headline>
                );
              })}
              <Headline
                el="li"
                className={`${s.cartItem} ${s.mobileHeading}`}
                center
                h6
              >
                {`${cart.quantity} ${cart.quantity > 1 ? 'items' : 'item'}`}
              </Headline>
            </ul>
          </li>
          {cart.cartItems &&
            cart.cartItems.map(item => (
              <CartItem item={item} cart={cart} key={item.id} />
            ))}
        </ul>
      ) : (
        <>
          <div className={s.noItems}>
            <Headline h5 el="p">
              Cart is empty.
            </Headline>
            <Button href="/" className={s.shopNow} small>
              Shop now!
            </Button>
          </div>
        </>
      )}
    </Container>
  );
}

function CartItem({ item, cart }) {
  const {
    productTitle,
    quantity,
    price,
    id,
    removeItem,
    editItem,
    imageId,
    handle
  } = item;
  const total = Math.round(Number(price) * quantity * 100) / 100;
  // const
  return (
    <li className={s.productItemWrapper} key={id}>
      <ul className={s.productsList}>
        <li className={`${s.cartItem} ${s.blank}`}>
          <div className={s.image}>
            <Img src={imageId} className={s.img} />
            <button className={s.delete} type="button" onClick={removeItem}>
              <Icon
                icon={cart.spin[id] ? 'spinner' : 'times'}
                className={cart.spin[id] ? 'animate-spin' : ''}
              />
            </button>
          </div>
          <Link to={`/product/${handle}`} className={s.productTitle}>
            {productTitle}
          </Link>
        </li>
        <li className={`${s.cartItem} ${s.price}`}>
          <p className={s.green}>
            <span>Price: </span>
            {`$${price}`}
          </p>
        </li>
        <li className={`${s.cartItem} ${s.quantity}`}>
          <div className={s.counterWrapper}>
            <Counter
              small
              quantity={quantity}
              editItem={editItem}
              edit={cart.edit[id]}
            />
            {cart.edit[id] && Number(price) === total && (
              <span className={s.countSpinner}>
                <Icon
                  icon="spinner"
                  className={`animate-spin ${s.spinnerEdit}`}
                />
              </span>
            )}
          </div>
        </li>
        <li
          className={`${s.cartItem} ${s.total} ${
            Number(price) === total ? s.equal : ''
          }`}
        >
          <p className={s.green}>
            <span>Total: </span>
            {cart.edit[id] ? (
              <Icon
                icon="spinner"
                className={`animate-spin ${s.spinnerEdit}`}
              />
            ) : (
              `$${total.toFixed(2)}`
            )}
          </p>
        </li>
      </ul>
    </li>
  );
}
